import request from "@/config/utils/request";

// 获取列表数据
export function getUserList(data) {
  return request({
    url: "/apis/demo/template/listDemoUsers",
    method: "post",
    data
  });
}

// 删除
export function removeDemo(data) {
  return request({
    url: "/apis/demo/template/removeDemo",
    method: "post",
    data
  });
}
